import { Card, Col, Row } from 'antd'
import type { Gutter } from 'antd/lib/grid/row'
import clsx from 'clsx'
import Skeleton from 'react-loading-skeleton'

import { useDeviceDetect } from '@/hooks'
import useDummyItems from '@/hooks/useDummyItems'

import styles from './B2becCardSkeleton.module.scss'

const defaultColumns = { xs: 24, sm: 24, md: 12, lg: 8, xl: 8, xxl: 6 }

interface B2becCardSkeletonProps {
  number?: number
  imageHeight?: number
  className?: string
  style?: React.CSSProperties
  gutter?: Gutter | [Gutter, Gutter]
  columns?: {
    xs?: number
    sm?: number
    md?: number
    lg?: number
    xl?: number
    xxl?: number
  }
  hasPrice?: boolean
}

const B2becCardSkeleton = ({
  number = 6,
  imageHeight = 320,
  className,
  style,
  gutter,
  columns = defaultColumns,
  hasPrice = true,
}: B2becCardSkeletonProps) => {
  const fakeProducts = useDummyItems(number)
  const { isLargeScreen } = useDeviceDetect()

  const renderMobileSkeletonProductCard = () => (
    <Card className={`product-card__content-container ${className}`}>
      <div className="flex">
        <div style={{ flex: 1 }}>
          <Skeleton height={140} width={140} />
        </div>

        <div className="product-card__content--right-wrapper product-card-skeleton__content--right-wrapper">
          <p className="product-card__content-name">
            <Skeleton />
          </p>

          <p className="product-card__content-name">
            <Skeleton />
          </p>

          <p className="product-card__content-name">
            <Skeleton />
          </p>
        </div>
      </div>
    </Card>
  )

  const renderSkeletonProductCard = () => (
    <Card
      className={hasPrice
        ? `card-item__container--price ${className}`
        : `card-item__container--non-price ${className}`}
    >
      <div className="ant-card-cover">
        <Skeleton height={imageHeight} />
      </div>
      <div className={`card-item__title ${styles.title}`}>
        <Skeleton />
      </div>
      <div className="card-item__item-number">
        <Skeleton />
      </div>
    </Card>
  )

  const containerClass = clsx(
    isLargeScreen
      ? 'card-skeleton__container'
      : 'full-width-page-component__wrapper',
  )

  return (
    <div className={containerClass}>
      <Row
        className={`${styles.wrapper} ${className}`}
        gutter={gutter}
        style={style}
      >
        {fakeProducts.map(({ materialNumber }) => (
          <Col
            key={materialNumber}
            className="card-item"
            lg={columns.lg}
            md={columns.md}
            sm={columns.sm}
            xl={columns.xl}
            xs={columns.xs}
            xxl={columns.xxl}
          >
            {isLargeScreen
              ? renderSkeletonProductCard()
              : renderMobileSkeletonProductCard()}
          </Col>
        ))}
      </Row>
    </div>
  )
}

export default B2becCardSkeleton
